import { Component, OnInit, ViewChild } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { MatTabChangeEvent, MatRadioChange, MatSidenav } from '@angular/material';

import { Inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService  } from '@ngx-translate/core';

import { WorksService } from '../../../../../services/works.service';
import { SharingDataService } from '../../../../../services/sharing-data.service';

import { WksWorksModel,
          IhmOptions, WksEntity, InternationalsFormats,
          PartsRequirement,
          OrderParts,
          ToolArgs,
          ToolKeyValue,
          ToolApiResponse,
          MessageDisplay} from '../../../../../models';

import { ModalCommonComponent } from 'src/app/components/common/modal-common/modal-common.component';


@Component({
  selector: 'app-works-output-stocks',
  templateUrl: './works-output-stocks.component.html',
  styleUrls: ['./works-output-stocks.component.less']
})
export class WorksOutputStocksComponent implements OnInit {

  modalTitle: string;
  workId: string;
  sidenavCollapsed = true;
  private readonly onDestroy = new Subject<void>();
  @ViewChild('sidenav', {static: false}) mSidenav: any;

  messageDialogRef: MatDialogRef<ModalCommonComponent>;

  workCur: WksWorksModel;
  outputStocksIsLoaded: boolean;
  itemChoose: string;
  nameParent: string;

  ihmOptions: IhmOptions;
  ihmOptionsStock: IhmOptions;
  wksEntity: WksEntity;
  internationalsFormats: InternationalsFormats;
  dateFormat: string;
  dateFormatMoment: string;
  dateTimeFormat: string;
  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
  };
  isReadOnly: boolean;

  isOkToValid: boolean[];
  dataLabelCur: string[];

  ordersParts: OrderParts[];
  ordersPartsCache: OrderParts[];

  constructor(private dialogRef: MatDialogRef<WorksOutputStocksComponent>,
              private worksService: WorksService,
              private translateService: TranslateService,
              private sharingDataService: SharingDataService,
              private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) data: any) {
                this.modalTitle = data.title;
                this.workId = data.workId;

  }

 ngOnInit(): void {
    this.initBooleans();
    if (this.ihmOptions !== undefined) {
      this.isReadOnly = this.ihmOptions.readOnly;
      this.ihmOptionsStock = this.ihmOptions;
    }
    this.worksService.getWorksById(this.workId)
    .subscribe(
      data => {
        this.workCur = data.body as WksWorksModel;
        if (this.ihmOptions === undefined) {
          this.getIhmOptions();
        }
        if (this.workCur.workCustomer.bsnAddress) {
          const dataAddress = JSON.parse(this.workCur.workCustomer.bsnAddress);
          if ((this.workCur.workCustomer.bsnType === 'company') || (this.workCur.workCustomer.bsnType === 'administration')) {
            this.nameParent = dataAddress.corporateName;
          } else {
            this.nameParent = dataAddress.identity.cntLastname + ' ' + dataAddress.identity.cntFirstname;
          }
        }

        this.fillPartsList();

        this.outputStocksIsLoaded = true;
      },
      err =>  {
        console.log('getWorksById ' + err.message);
      }
    );
    this.buildForm();
  }
  buildForm(): void {

    this.dataLabelCur = [];
    this.dataLabelCur[0] = this.translateService.instant('OUTPUT_STOCK.suppliesLabel');
    this.dataLabelCur[1] = this.translateService.instant('OUTPUT_STOCK.brandRef');
    this.dataLabelCur[2] = this.translateService.instant('OUTPUT_STOCK.billingUnit');
    this.dataLabelCur[3] = this.translateService.instant('OUTPUT_STOCK.quantity');
    this.dataLabelCur[4] = this.translateService.instant('OUTPUT_STOCK.withdrawal');
    /*
    this.dataLabelCur[5] = this.translateService.instant('OUTPUT_STOCK.inStock');
    this.dataLabelCur[6] = this.translateService.instant('OUTPUT_STOCK.ouputStock');
    this.dataLabelCur[7] = this.translateService.instant('OUTPUT_STOCK.movementStock');
*/
    this.wksEntity = this.sharingDataService.getWksEntity();
    const otherData = JSON.parse(this.wksEntity.otherData);
    const internationnalFormat = otherData.internationnalFormat;
    this.internationalsFormats = this.sharingDataService.getIntFormat(internationnalFormat);
    for (const fmtCur of this.internationalsFormats.datetime) {
      if (fmtCur.name === 'dateFormat') {
        this.dateFormat = fmtCur.value;
        this.dateFormatMoment = fmtCur.value;
        this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
        this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
      }
      if (fmtCur.name === 'timeFormat') {
        this.dateTimeFormat = fmtCur.value;
        this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
        this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
      }

    }
    this.numberFormat = {
      locale: this.sharingDataService.getFormat(internationnalFormat, 'numbers', 'locale'),
      minDecimal: this.sharingDataService.getFormat(internationnalFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this.sharingDataService.getFormat(internationnalFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this.sharingDataService.getFormat(internationnalFormat, 'numbers', 'currency'),
    };
  }
  getIhmOptions(): void {
    this.ihmOptions = {
      readOnly: true
    };
    this.ihmOptionsStock = {
      readOnly: true
    };
    if (this.workCur === undefined) {
      return;
    }
    this.ihmOptions = this.worksService.getIhmOptions(this.workCur.workStatut, 'ouputStockTab');
    this.ihmOptionsStock = this.ihmOptions;
    this.ihmOptionsStock.collapse = false;
  }
  initBooleans(): void {
    this.outputStocksIsLoaded = false;
    this.isReadOnly = true;
    this.isOkToValid = [];
  }
  toggleSidenav(): void {
    this.sidenavCollapsed = !this.sidenavCollapsed;
    if (this.sidenavCollapsed) {
      this.mSidenav.close();
    } else {
      this.mSidenav.open();
    }
  }
  toggleBackdropSidenav(): void {
    this.sidenavCollapsed = true;
    this.mSidenav.close();
  }
  fillPartsList(): void {
    let orderedParts: PartsRequirement[] = [];
    if (this.workCur.workJsonData) {
      const workJsonData = JSON.parse(this.workCur.workJsonData);
      if (workJsonData.orderedParts) {
        orderedParts = JSON.parse(JSON.stringify(workJsonData.orderedParts));
      }
    }

    this.repartOrdersParts(orderedParts);
    this.ordersPartsCache = JSON.parse(JSON.stringify(this.ordersParts));

  }
  repartOrdersParts(partsRequirementAll: PartsRequirement[]): void {
    this.ordersParts = [];
     // orders parts
    let orderRefTmp = '';
    let idxOrderCur = 0 ;
    for (const partItem of  partsRequirementAll) {
      if (partItem.nws_order_ref === undefined) {
        orderRefTmp = 'NOT_RESERVED';
      } else {
        orderRefTmp = partItem.nws_order_ref;
      }
      if (partItem.withdrawal === undefined) {
        partItem.withdrawal = 'no';
      }
      let isOrderFound = false;
      for (const orderItem of this.ordersParts) {
        if (orderItem.nws_order_ref !== orderRefTmp) {
          continue;
        }
        isOrderFound = true;
        if (orderItem.partsRequirement === undefined) {
          orderItem.partsRequirement = [];
        }
        orderItem.partsRequirement.push(partItem);
      }
      if (!isOrderFound) {
        const orderTmp: OrderParts = {
          nws_order_ref: orderRefTmp,
          nws_order_id: partItem.nws_order_id,
          idxOrder: idxOrderCur,
          actionOrder: orderRefTmp === 'NOT_RESERVED' ? 'reserveStockParts' : 'removeOrderParts',
          partsRequirement: [],
          isCollapsed: true,
        };
        orderTmp.partsRequirement.push(partItem);
        this.ordersParts.push(orderTmp);
        this.isOkToValid[idxOrderCur] = false;
        idxOrderCur++;
      }
    }
  }
  withdrawalPartChange(value: boolean, iPart: number, iOrder: number ): void {

    switch (value) {
      case true: {
        this.ordersParts[iOrder].partsRequirement[iPart].withdrawal = 'yes';
        this.dataOutValid(iOrder);
        break;
      }
      case false: {
        this.ordersParts[iOrder].partsRequirement[iPart].withdrawal = 'no';
        this.dataOutValid(iOrder);
        break;
      }
      default : {

        break;
      }
    }
  }
  dataOutValid(iOrder: number): void {
    this.isOkToValid[iOrder] = false;
    if ((JSON.stringify(this.ordersParts[iOrder])) !== (JSON.stringify(this.ordersPartsCache[iOrder]))) {
      this.isOkToValid[iOrder] = true;
    }
  }
  eventStock(field: string, value: number, idxPart: number, partsRequirement: PartsRequirement[], orderIdx: number): void {

    switch (field) {
      case 'inputStock': {

        partsRequirement[idxPart].movementStock += value;
        partsRequirement[idxPart].inputStock += value;
        partsRequirement[idxPart].outputStock -= value;

        break;
      } // end case
      case 'outputStock': {
        if ((partsRequirement[idxPart].movementStock + value) * -1 > partsRequirement[idxPart].inStock) {
          break;
        }
        if (partsRequirement[idxPart].outputStock + (value * -1) > partsRequirement[idxPart].quantity) {
          break;
        }

        partsRequirement[idxPart].movementStock += value;
        partsRequirement[idxPart].outputStock += (value * -1) ;

        break;
      } // end case

      default: {

        break;
      } // end case
    }
  }
  ouputStockParts(orderIdx: number): any {

    if (!this.verifyOutputAllParts(orderIdx)) {
      this.validData();
      this.isOkToValid[orderIdx] = false;
      return;
    }
    const apiService = 'orderClose';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    const toolKeyValue: ToolKeyValue = {
      key: 'nws_order_id',
      value: this.ordersParts[orderIdx].nws_order_id,
      listValues: undefined,
      arrayValues: undefined
    };
    const jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    const messageDisplay: MessageDisplay = {
      titleBox: 'ouputStockPartsTitle',
      messageLabel: undefined,
      messageArgs: undefined,
      messageBox: this.translateService.instant('OUTPUT_STOCK.ouputStockPartsMes', {orderRef: this.ordersParts[orderIdx].nws_order_ref}),
      messageType: 'ERROR',
      messageDatas: undefined,
      typeDialog: 'infoProgressWks',
      actionCur: 'ouputStockParts',
      progressDeterminate: false,
    };
    this.messageBoxDisplay(messageDisplay);

    this.worksService.requestApis(this.workCur.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {
        this.closeMatDialog();
        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {
          this.affectResponse(toolApiResponse, 'ouputStockParts', 'KO', orderIdx);
          this.validData();
          const messageDisplay2: MessageDisplay = {
            titleBox: 'ouputStockPartsTitle',
            messageLabel: undefined,
            messageArgs: undefined,
            messageBox: this.translateService.instant('OUTPUT_STOCK.ouputStockPartsKO',
                        {orderRef: this.ordersParts[orderIdx].nws_order_ref}),
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'alertWks',
            actionCur: 'ouputStockPartsKO',
            progressDeterminate: false,
          };
          this.messageBoxDisplay(messageDisplay2);
        } else  {
          const messageDisplay1: MessageDisplay = {
            titleBox: 'reserveStockPartsTitle',
            messageLabel: undefined,
            messageArgs: undefined,
            messageBox: this.translateService.instant('OUTPUT_STOCK.ouputStockPartsOK',
                        {orderRef: this.ordersParts[orderIdx].nws_order_ref}),
            messageType: 'INFO',
            messageDatas: undefined,
            typeDialog: 'alertWks',
            actionCur: 'ouputStockPartsOK',
            progressDeterminate: false,
          };
          this.messageBoxDisplay(messageDisplay1);
          this.affectResponse(toolApiResponse, 'ouputStockParts', 'OK', orderIdx);
          this.validData();
        }
      },
      err => {
        this.closeMatDialog();
        const toolParamReturn = err.error as ToolApiResponse;
        toolParamReturn.statut = err.status.toString();
        this.affectResponse(toolParamReturn, 'reserveStockParts', 'KO', orderIdx);
        this.validData();
        const messageDisplay2: MessageDisplay = {
          titleBox: 'testApi',
          messageLabel: undefined,
          messageArgs: undefined,
          messageBox: this.translateService.instant('OUTPUT_STOCK.ouputStockPartsKO',
                      {orderRef: this.ordersParts[orderIdx].nws_order_ref}),
          messageType: 'ERROR',
          messageDatas: undefined,
          typeDialog: 'alertWks',
          actionCur: 'testApiKO',
          progressDeterminate: false,
        };
        this.messageBoxDisplay(messageDisplay2);
      }
    );

  }
  verifyOutputAllParts(orderIdx: number ): boolean {
    let isOuputAll = true;
    for (const itemPart of this.ordersParts[orderIdx].partsRequirement) {
      if (itemPart.withdrawal === 'no') {
        isOuputAll = false;
        break;
      }
    }
    return isOuputAll;
  }
  affectResponse( toolApiResponse: ToolApiResponse, action: string, statut: string, orderIdx: number ): void {
    if (statut === 'OK') {
      /*
      if (action === 'reserveStockParts') {
        let nwsOrderId ;
        let nwsOrderRef ;

        for (const itemData of toolApiResponse.toolDatas) {
          if (itemData.key === 'nws_order_id') {
            nwsOrderId = itemData.value;
            continue;
          }
          if (itemData.key === 'nws_order_ref') {
            nwsOrderRef = itemData.value;
            continue;
          }
        }
      }
        */
    }
  }
  validData(): any {
    const workCard = this.fillModel();
    // console.log(JSON.stringify(workCard));
    return new Promise((resolve, reject) => {
      this.worksService.saveWorks(workCard, 'outputStock').subscribe(result => {
        const reponseCur = result.body;

        // this.dialogRef.close();
        resolve(reponseCur);
      },
      err => {
        console.log(err);
        reject(err.status);
      });
    });
  }
  fillModel(): WksWorksModel {
    const partsRequirementOrdered: PartsRequirement[] = [];
    for (const orderItem of this.ordersParts) {
      partsRequirementOrdered.push(...orderItem.partsRequirement);
    }

    const workJsonData = JSON.parse(this.workCur.workJsonData);

    workJsonData.orderedParts = partsRequirementOrdered;
    const wksWorkCard: WksWorksModel = JSON.parse(JSON.stringify(this.workCur));
    wksWorkCard.workJsonData = JSON.stringify(workJsonData);
    // Provisoire pour compatibilité descendante (Transmosition UUID `java.util.UUID` from String "20221118BFLPCKUR6G1MCOQZH")
    // dans environnement de dev
    wksWorkCard.workTasksContent = undefined;
    // fin provisoire
    return wksWorkCard;

  }
 // ========================================================== errors alerts
 messageBoxDisplay(messageDisplay: MessageDisplay): void {

  const dialogConfig = new MatDialogConfig();
  let messageBox = '';
  if (messageDisplay.messageBox !== undefined) {
    messageBox = messageDisplay.messageBox;
  } else  {
    messageBox = this.translateService.instant('OUTPUT_STOCK.' + messageDisplay.messageLabel, messageDisplay.messageArgs );
  }

  // const messageDisplayCACHE = JSON.parse(JSON.stringify(messageDisplay));
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.data = {
    id: 1,
    title: this.translateService.instant( 'OUTPUT_STOCK.' + messageDisplay.titleBox),
    typeDialog: messageDisplay.typeDialog,
    panelClass: 'stdTheme',
    contentMessage: messageBox,
    data1: messageDisplay.messageDatas,
    data2: '',
    actionCur: messageDisplay.actionCur,
    progressDeterminate: messageDisplay.progressDeterminate,
    errorsList: undefined,
    messageType: messageDisplay.messageType
  };
  this.messageDialogRef = this.matDialog.open(ModalCommonComponent, dialogConfig);

  this.messageDialogRef.afterClosed()
  .pipe(takeUntil(this.onDestroy))
  .subscribe(
    (data: any) => {
      // data: "okAction"
      if (data === 'okAction') {
        if (messageDisplay.actionCur === 'verifyStockParts') {
          this.endProcessFile();
        }
        if (messageDisplay.actionCur === 'verifyStockPartsDone') {
          this.endProcessFile();
        }
        if (messageDisplay.actionCur === 'verifyStockPartsFailed') {
          this.endProcessFile();
        }

      }
    });
  }
  closeMatDialog(): void {
    this.matDialog.closeAll();

    // console.log(this._dialog.openDialogs.length);
    if (this.matDialog.openDialogs.length > 0) {

      for (const instCur of this.matDialog.openDialogs) {
        this.matDialog.openDialogs.splice(0, 1);
      }
    }
    this.messageDialogRef = null;
  }
  private endProcessFile(): void {
    this.closeMatDialog();
  }
  closeModal(): void {
    this.dialogRef.close();
  }
}
